import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ItemType } from '../../types';
import { hashingData } from './functionSlice';

export interface IGantItemsState {
    itemsList: ItemType[];
    currentGantItem: ItemType | null;
    inputItems: ItemType[];
    isItemEdit: boolean;
    wasChanged: boolean;
    externalTableScheduleItemPrefixFetchKey?: string;
}

const initialState: IGantItemsState = {
    itemsList: [],
    currentGantItem: null,
    inputItems: [],
    isItemEdit: false,
    wasChanged: false,
    externalTableScheduleItemPrefixFetchKey: '',
};

const storeHash: { [key: string]: number } = {};

export const gantItemsSlice = createSlice({
    name: 'gantItems',
    initialState,
    reducers: {
        setterGantItems: (state, action: PayloadAction<Partial<IGantItemsState>>) => {
            hashingData(storeHash, action.payload, 'itemsList');
            hashingData(storeHash, action.payload, 'inputItems');

            if (!Object.keys(action.payload).length) {
                return state;
            }

            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

export const { setterGantItems } = gantItemsSlice.actions;

export default gantItemsSlice.reducer;
